/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_When_YesterdayInputs */

const en_us2_workout_quick_when_yesterday = /** @type {(inputs: Workout_Quick_When_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yesterday`)
};

const pt_br2_workout_quick_when_yesterday = /** @type {(inputs: Workout_Quick_When_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontem`)
};

const es_419_workout_quick_when_yesterday = /** @type {(inputs: Workout_Quick_When_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayer`)
};

const pt_pt2_workout_quick_when_yesterday = /** @type {(inputs: Workout_Quick_When_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontem`)
};

const fr_fr2_workout_quick_when_yesterday = /** @type {(inputs: Workout_Quick_When_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier`)
};

const de_de2_workout_quick_when_yesterday = /** @type {(inputs: Workout_Quick_When_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestern`)
};

const it_it2_workout_quick_when_yesterday = /** @type {(inputs: Workout_Quick_When_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ieri`)
};

/**
* | output |
* | --- |
* | "Yesterday" |
*
* @param {Workout_Quick_When_YesterdayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_when_yesterday = /** @type {((inputs?: Workout_Quick_When_YesterdayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_When_YesterdayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_when_yesterday(inputs)
	if (locale === "es-419") return es_419_workout_quick_when_yesterday(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_when_yesterday(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_when_yesterday(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_when_yesterday(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_when_yesterday(inputs)
	return en_us2_workout_quick_when_yesterday(inputs)
});
export { workout_quick_when_yesterday as "workout-quick.when_yesterday" }